













import { defineComponent, ref } from '@vue/composition-api';
import { i18n } from '@tt4b/ttam-i18n';
import { ValidationError } from '@tt4b/ttam-hooks';
import { trim } from 'lodash-es';

const LENGTH_LIMIT_MAX = 200;

export default defineComponent({
  props: {
    value: {
      type: String,
      required: true,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const validateRule = [
      {
        validator: (rule, value: string, callback: (...params) => void) => {
          if (!value?.length) {
            return callback(
              new ValidationError({
                message: i18n.t('payer_name_invalid_tips_empty'),
                messageI18nKey: 'payer_name_invalid_tips_empty',
                moduleName: i18n.t('adgroup_payer_card'),
                subModuleName: i18n.t('item_label_name_payer_name'),
              }),
            );
          }
          if (value?.length > LENGTH_LIMIT_MAX) {
            return callback(
              new ValidationError({
                message: i18n.t('payer_name_invalid_tips_too_long'),
                messageI18nKey: 'payer_name_invalid_tips_too_long',
                moduleName: i18n.t('adgroup_payer_card'),
                subModuleName: i18n.t('item_label_name_payer_name'),
              }),
            );
          }

          return callback();
        },
        trigger: 'blur',
      },
    ];
    const inputRef = ref();
    const changePayerName = (payerName: string) => {
      const targetValue = trim(payerName);
      ctx.emit('change', targetValue);

      // 由于VUI内部实现保存了一份本地的value数据，在输入值连续多次trim后，由于传入的props未发生变化
      // 组件展示就未同步更新，这里做一个强制的组件展示值的更新，保证连续trim有效
      try {
        inputRef.value._data.currentValue = targetValue;
      } catch (e) {}
    };

    return {
      inputRef,
      validateRule,
      changePayerName,
    };
  },
});
